export function formatPageTitle(title: string): string {
  return title.includes('AceSense') ? title : `${title}: AceSense`
}
